import RouteWithLayout from "./RouteWithLayout";

export default RouteWithLayout;
